'use client';

import React from 'react';

interface Contrast {
  insufficient: string;
  required: string;
}

const ExistingApproaches = () => {
  const contrasts: Contrast[] = [
    {
      insufficient: 'Project-based change',
      required: 'Continuous change',
    },
    {
      insufficient: 'Tool deployment',
      required: 'Behavioural adoption',
    },
    {
      insufficient: 'Training programmes',
      required: 'Leadership accountability',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-6 leading-tight">
              Why Existing Approaches Fall Short
            </h2>
            <p className="text-xl text-gray-700 font-body leading-relaxed">
              Traditional change management and AI strategy approaches were not designed for the continuous, organisation-wide transformation that AI demands.
            </p>
          </div>

          {/* Contrasts */}
          <div className="space-y-8">
            {contrasts.map((contrast, index) => (
              <div key={index} className="grid md:grid-cols-2 gap-8">
                <div className="p-6 bg-gray-50 border-l-4 border-gray-300">
                  <div className="text-sm font-semibold text-gray-500 font-body mb-2 uppercase tracking-wide">
                    Insufficient
                  </div>
                  <div className="text-xl font-semibold text-gray-600 font-headline">
                    {contrast.insufficient}
                  </div>
                </div>
                <div className="p-6 bg-[#0A2540] border-l-4 border-[#0A2540]">
                  <div className="text-sm font-semibold text-white/70 font-body mb-2 uppercase tracking-wide">
                    Required
                  </div>
                  <div className="text-xl font-semibold text-white font-headline">
                    {contrast.required}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Diagnostic statement */}
          <div className="mt-16">
            <div className="p-8 border-2 border-gray-200">
              <p className="text-lg text-gray-800 font-body leading-relaxed mb-4">
                AI operates at machine speed. It evolves continuously. It touches every function. It requires new behaviours from every employee.
              </p>
              <p className="text-lg text-gray-800 font-body leading-relaxed">
                Traditional approaches—designed for discrete projects with defined endpoints—cannot keep pace with this reality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExistingApproaches;